<template>
  <div class="developerPage">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80:50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column
        prop="app"
        label="APP"
        align="center"
        min-width="110"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.app">{{scope.row.app}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userId"
        label="开发者"
        align="center"
        min-width="90"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.user">{{scope.row.user.name}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="email" label="邮箱" align="center" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.user">{{scope.row.user.email}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="publicKey"
        label="公钥"
        align="center"
        min-width="120"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.publicKey">{{scope.row.publicKey}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="privateKey"
        label="私钥"
        align="center"
        min-width="120"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.privateKey">{{scope.row.privateKey}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="enable" label="状态" align="center" width="95px" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="textSuccess" v-if="scope.row.enable">启用</span>
          <span class="textWarning" v-else>禁用</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="130px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
            <i @click="editDeveloper($event, scope.row)" class="el-icon-edit"></i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.enable"
            class="item"
            effect="dark"
            content="禁用"
            placement="top"
            :open-delay="300"
          >
            <i @click="disableDeveloper($event, scope.row)" class="iconfont icon-qiyong"></i>
          </el-tooltip>
          <el-tooltip
            v-else
            class="item"
            effect="dark"
            content="启用"
            placement="top"
            :open-delay="300"
          >
            <i @click="enableDeveloper($event, scope.row)" class="iconfont icon-jinyong"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="上移" placement="top" :open-delay="300">
            <i @click="moveUpDeveloper($event, scope.row)" class="el-icon-arrow-up"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="下移" placement="top" :open-delay="300">
            <i @click="moveDownDeveloper($event, scope.row)" class="el-icon-arrow-down"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getOpenKeySearch"
    ></pagination>
    <myDialog
      ref="developerDialog"
      :title="developerDialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="developerDialogForm"
          :model="developerDialogForm"
          :rules="developerDialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="APP" size="small" prop="app">
            <el-input
              v-model="developerDialogForm.app"
              placeholder="APP名称，如：AONI-OA、AONI-ERP等"
              clearable
              :disabled="isEditState"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" size="small" prop="email">
            <el-input
              v-model="developerDialogForm.email"
              placeholder="用户在系统中注册的邮箱"
              clearable
              :disabled="isEditState"
            ></el-input>
          </el-form-item>
          <div v-if="isEditState">
            <el-form-item label="公钥" size="small" prop="publicKey" class="refreshBox">
              <el-input
                v-model="developerDialogForm.publicKey"
                placeholder="公钥"
                clearable
                :disabled="isEditState"
              ></el-input>
              <i class="el-icon-refresh icon" @click="refreshKeyBtn('publicKey')"></i>
            </el-form-item>
            <el-form-item label="私钥" size="small" prop="privateKey" class="refreshBox">
              <el-input
                v-model="developerDialogForm.privateKey"
                placeholder="私钥"
                clearable
                :disabled="isEditState"
              ></el-input>
              <i class="el-icon-refresh icon" @click="refreshKeyBtn('privateKey')"></i>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiOpenKeySearch,
  apiOpenKeyAdd,
  apiOpenKeyUpdate,
  apiOpenKeyDisable,
  apiOpenKeyEnable,
  apiOpenKeyMoveUp,
  apiOpenKeyMoveDown,
  apiOpenKeyGeneratorKey
} from "@/api/plantSetting.js";
export default {
  components: {
    pagination,
    myDialog
  },
  props: {
    developerSearchForm: {
      type: Object
    }
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      developerDialogTitle: "",
      developerDialogForm: {},
      developerDialogRules: {
        app: [
          { required: true, message: "APP名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 32,
            message: "长度在 2 到 32 个字符",
            trigger: "change"
          }
        ],
        email: [
          { required: true, message: "邮箱不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 64,
            message: "长度在 4 到 64 个字符",
            trigger: "change"
          }
        ],
        privateKey: [
          { required: true, message: "私钥不能为空！", trigger: "blur" }
        ],
        publicKey: [
          { required: true, message: "公钥不能为空！", trigger: "blur" }
        ]
      },
      isEditState: false,
      labelWidth: "60px"
    };
  },
  methods: {
    // 表格数据
    async getOpenKeySearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiOpenKeySearch({
        ...this.developerSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getOpenKeySearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getOpenKeySearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getOpenKeySearch();
    },
    // 添加APP
    addDeveloperBtn() {
      this.isEditState = false;
      this.developerDialogTitle = "添加APP";
      this.$refs.developerDialog.dialogVisible = true;
    },
    // 修改APP
    editDeveloper(e, row) {
      this.isEditState = true;
      this.developerDialogTitle = "修改APP";
      this.$refs.developerDialog.dialogVisible = true;
      this.developerDialogForm = {
        id: row.id,
        app: row.app,
        email: row.user.email,
        publicKey: row.publicKey,
        privateKey: row.privateKey
      };
    },
    // 更新密钥
    async refreshKeyBtn(name) {
      const res = await apiOpenKeyGeneratorKey();
      // console.log(res);
      if(res.code == 0) {
        this.$set(this.developerDialogForm, name, res.data)
      }
    },
    // 对话框提交
    submitData(title) {
      this.$refs.developerDialogForm.validate(async valid => {
        if (valid) {
          let res = {};
          if (title == "添加APP") {
            res = await apiOpenKeyAdd({
              ...this.developerDialogForm
            });
            if (res.code == 0) {
              this.$refs.developerDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getOpenKeySearch();
              this.$message({
                message: "添加成功",
                type: "success"
              });
            }
          } else if (title == "修改APP") {
            res = await apiOpenKeyUpdate({
              ...this.developerDialogForm
            });
            if (res.code == 0) {
              this.$refs.developerDialog.dialogVisible = false;
              this.getOpenKeySearch("noRemove");
              this.$message({
                message: "修改成功",
                type: "success"
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.developerDialogForm.resetFields();
      this.developerDialogForm = {};
    },
    // 禁用
    disableDeveloper(e, row) {
      e.target.blur();
      this.$allOperation({name:row.app}, "禁用", "APP").then(async () => {
        const res = await apiOpenKeyDisable({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getOpenKeySearch("noRemove");
          this.$message({
            message: "禁用成功",
            type: "success"
          });
        }
      });
    },
    // 启用
    enableDeveloper(e, row) {
      e.target.blur();
      this.$allOperation({name:row.app}, "启用", "APP").then(async () => {
        const res = await apiOpenKeyEnable({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getOpenKeySearch("noRemove");
          this.$message({
            message: "启用成功",
            type: "success"
          });
        }
      });
    },
    // 上移
    moveUpDeveloper(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.app}】？`, "上移APP", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiOpenKeyMoveUp({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getOpenKeySearch("noRemove");
          this.$message({
            message: "上移成功",
            type: "success"
          });
        }
      });
    },
    // 下移
    moveDownDeveloper(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.app}】？`, "下移APP", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiOpenKeyMoveDown({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getOpenKeySearch("noRemove");
          this.$message({
            message: "下移成功",
            type: "success"
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.developerPage {
  height: 100%;
  display: flex;
  flex-direction: column;
  .refreshBox {
    /deep/.el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-input {
        width: 92%;
      }
      .icon {
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>